import {createElementAnd, raf} from "./util";

export function registerExpandableContent() {
    raf(() => Array.prototype.slice.call(document.querySelectorAll("div.expandable-content")).forEach(content => raf(() => initExpandableContent(content))));
}

function initExpandableContent(content) {
    const maxHeight = content.dataset.maxHeight || "100px";
    const currentHeight = content.getBoundingClientRect().height;

    const mhInt = parseInt(maxHeight);
    const chInt = parseInt(currentHeight);

    if ((mhInt + 96) >= chInt) {
        while (content.firstChild) {
            const child = content.firstChild;

            child.parentNode.removeChild(child);
            content.parentNode.insertBefore(child, content.parentNode.firstChild);
        }

        content.parentNode.removeChild(content);
        return;
    }

    const readLess = content.dataset.readLess || "Read less";
    const readMore = content.dataset.readMore || "Read more";

    content.style.setProperty("max-height", maxHeight);

    const expander = createElementAnd("div", div => {
        div.classList.add("expander");
        div.innerHTML = readMore;
        content.appendChild(div);
    });

    expander.addEventListener("click", () => {
        if (content.classList.contains("is-expanded")) {
            content.classList.remove("is-expanded");
            expander.innerHTML = readMore;
        } else {
            content.classList.add("is-expanded");
            expander.innerHTML = readLess;
        }
    });
}
